import React from "react";
import construction from "./images/construction.png";

function Contacts() {
  return (
    <div className="center">
      <img
        width="50%"
        height="50%"
        position="relative"
        src={construction}
        alt="under_construction"
      ></img>
    </div>
  );
}

export default Contacts;
